import React from "react";
import { Grid } from "@mui/material";
import FormField from "layouts/pages/account/components/FormField";
import SoftTypography from "components/SoftTypography";
import SoftBox from "components/SoftBox";
import SettingsCard from "./SettingsCard";

const HomePageHeadingsSection = ({ 
  inputData,
  img_1,
  previewImg1,
  handleImageUpload
}) => {
  return (
    <SettingsCard
      title="Home Page - Main Content"
      subtitle="Configure main headings and content for the home page"
      gridProps={{
        xs: 12,
        sx: {
          "@media (min-width: 1100px)": {
            flexBasis: "calc(50% - 12px)",
            maxWidth: "calc(50% - 12px)",
            width: "calc(50% - 12px)"
          }
        }
      }}
    >
      <Grid container spacing={2.5}>
        <Grid item xs={12}>
          <SoftBox 
            display="flex" 
            flexDirection="column"
            alignItems="flex-start" 
            mb={0}
            sx={{
              width: "100%",
              maxWidth: "400px"
            }}
          >
            <SoftBox
              sx={{
                width: "100%",
                maxWidth: "400px",
                height: "120px",
                border: "1.5px solid #e0e0e0",
                borderRadius: "12px",
                padding: "12px",
                backgroundColor: "#f9f9f9",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                overflow: "hidden",
                cursor: "pointer",
                position: "relative",
                mb: 0.25
              }}
              onClick={() => document.getElementById("img_1_input").click()}
            >
              <input type="hidden" name="img_1" value={img_1} />
              <img
                src={
                  previewImg1 ||
                  "https://storage.googleapis.com/msgsndr/6nC5xgng29ena72OMCSP/media/951aedee-d009-4b2e-b36b-9315e19f5c1b.png"
                }
                alt=""
                style={{ 
                  maxWidth: "100%", 
                  maxHeight: "100%", 
                  width: "auto", 
                  height: "auto",
                  objectFit: "contain",
                  borderRadius: "8px"
                }}
              />
              <input
                id="img_1_input"
                hidden
                accept="image/*"
                type="file"
                onChange={(e) => {
                  handleImageUpload(e, "img_1");
                  // Reset input value so same file can be selected again
                  e.target.value = "";
                }}
              />
            </SoftBox>
            <SoftTypography
              variant="caption"
              sx={{
                fontSize: "11px",
                color: "#666",
                marginTop: "6px"
              }}
            >
              Recommended: (300px x 150px) 2:1 ratio. 1MB size.
            </SoftTypography>
          </SoftBox>
        </Grid>
        {/* Heading */}
        <Grid item xs={12}>
          <FormField
            defaultValue={
              inputData?.heading_1 ||
              "Support Local - Discover & Support Small Businesses in Your Community"
            }
            label="Heading"
            name="heading_1"
          />
        </Grid>

        {/* Text 1 */}
        <Grid item xs={12}>
          <FormField
            defaultValue={
              inputData?.text_1 ||
              "Support Local is your go-to directory for finding trusted small businesses near you."
            }
            label="Text 1"
            name="text_1"
          />
        </Grid>

        {/* Text 2 */}
        <Grid item xs={12}>
          <FormField
            defaultValue={
              inputData?.text_2 ||
              "Explore shops, services, restaurants, and more — all in one place."
            }
            label="Text 2"
            name="text_2"
          />
        </Grid>
      </Grid>
    </SettingsCard>
  );
};

export default HomePageHeadingsSection;
